import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ADMIN_NAV } from "routes/APP_ROUTES";
import { ReactComponent as IconLogout } from "assets/icons/icon-logout.svg";
import { formattedTimeZone } from "helper/Functions";

const Sidebar = ({ isSidebarOpen, logout, toggleSidebar, user }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(new Date());

  const handleMenuClick = (path) => {
    navigate(path);
    // Close the sidebar on mobile view after clicking a menu item
    if (window.innerWidth > 991) {
      toggleSidebar(true);
    } else {
      toggleSidebar(false);
    }
  };

  const isActive = (path) => location.pathname === path;
  const adminNavItems = ADMIN_NAV();
  return (
    <>
      {/* Sidebar Menu */}
      <div
        className={`static top-0 w-full overflow-y-hidden bg-body text-white z-10 transform transition-transform duration-300 lg:max-w-[17.25rem] lg:min-w-[17.25rem] lg:h-full lg:right-0 lg:mt-0 lg:overflow-y-auto ${isSidebarOpen ? "lg:translate-x-0 top-full" : "lg:translate-x-full h-0"
          } `}
      >
        <div className="p-3">
          <div className="flex items-center">
            <div className="hidden lg:flex px-2 py-2  flex-col space-y-2">
              <div className="text-lg font-bold uppercase">{t("Agent Menu")}</div>
              <div className="text-sm mb-4 opacity-70">{formattedTimeZone()}</div>
            </div>
          </div>
          <ul className="sidebar-nav flex flex-col space-y-2">
            <hr className="border-white/10 mb-2" />
            {adminNavItems.map((item, index) => {
              // Skip rendering this item if it's "Online Users" and user role is not owner
              if (item.title === "Online Users" && user?.role !== "Owner") {
                return null;
              }

              return (
                <React.Fragment key={index}>
                  <li
                    className={`cursor-pointer px-[14px] py-2 rounded-lg flex items-center w-full transition duration-100 font-semibold hover:bg-primary text-[17px] ${isActive("/admin" + item.path)
                      ? "bg-primary [&_svg_path]:fill-white"
                      : "text-white [&_svg_path]:fill-white"
                      }`}
                    onClick={() => handleMenuClick("/admin" + item.path)}
                  >
                    <span className={`w-6 h-6 mr-3`}>{item.image}</span>
                    {item.title}
                  </li>
                  {(index === 1 || index === 5) && <hr className="border-white/10" />}
                </React.Fragment>
              );
            })}

            {/* Logout Section */}
            <hr className="border-white/10" />

            <li
              className={`cursor-pointer px-[14px] py-2 rounded-lg flex items-center w-full transition duration-300 font-semibold  [&_svg_path]:fill-white hover:bg-primary text-[17px] capitalize`}
              onClick={logout}
            >
              <span className={`mr-3`}>
                <IconLogout />
              </span>
              {t("logout")}
            </li>
          </ul>
          <hr className="border-white/10 my-2" />

          {/* User Info */}
          <div className="p-4 text-xs flex flex-col space-y-1 opacity-70 mb-5">
            <p className="text-sm">Last Login:</p>
            <p className="mt-5 text-sm">{new Date(user?.userdate).toLocaleString()}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
